//identifiers : https://www.notion.so/partipost/Comment-system-field-name-identifier-mapping-e4f5ff352d584b399bb7d2c3a37923b2
export const fieldIdentifiers = {
    brandName: 'brandName',
    campaignName: 'campaignName',
    objective: 'objective',
    categories: 'categories',
    budget: 'budget',
    slotNumber: 'slotNumber',
    isPrivate: 'isPrivate',
    registrationEnable: 'registrationEnable',
    registrationMaxSlots: 'registrationMaxSlots',
    autoUpdateSubmissionStatus: 'autoUpdateSubmissionStatus',
    submissionStatusFullMin: 'submissionStatusFullMin',
    submissionStatusFillingFastMin: 'submissionStatusFillingFastMin',
    batchEnable: 'batchEnable',
    campaignBanner: 'campaignBanner',
    campaignDescription: 'campaignDescription',
    payoutDeadline: 'payoutDeadline',
    setupTitle: 'setupTitle',
    setupDescription: 'setupDescription',
    setupImages: 'setupImages',
    start: 'start',
    end: 'end',
    reviewDuration: 'reviewDuration',
    invitationExpiry: 'invitationExpiry',
    stepTitle: 'stepTitle',
    stepDescription: 'stepDescription',
    photoRequirementDos: 'photoRequirementDos',
    photoRequirementDonts: 'photoRequirementDonts',
    examplePhotos: 'examplePhotos',
    examplePhotosDescription: 'examplePhotosDescription',
    captionRequirementDos: 'captionRequirementDos',
    captionRequirementDonts: 'captionRequirementDonts',
    captionRequirementHashtags: 'captionRequirementHashtags',
    profileTags: 'profileTags',
    videoCodeToggle: 'videoCodeToggle',
    linkInBioToggle: 'linkInBioToggle',
    engagementMetrics: 'engagementMetrics',
    schedulePostToggle: 'schedulePostToggle',
    payoutBase: 'payoutBase',
    extraPayoutTitle: 'extraPayoutTitle',
    extraPayoutDescription: 'extraPayoutDescription',
    extraPayoutCost: 'extraPayoutCost',
    extraPayoutMin: 'extraPayoutMin',
    extraPayoutMax: 'extraPayoutMax',
    engagementToggle: 'engagementToggle',
    engagementCost: 'engagementCost',
    engagementMin: 'engagementMin',
    engagementMax: 'engagementMax',
    productName: 'productName',
    productDescription: 'productDescription',
    howToBuyTitle: 'howToBuyTitle',
    productPhotos: 'productPhotos',
    photosDescription: 'photosDescription',
    purchaseProductToggle: 'purchaseProductToggle',
    attendEventToggle: 'attendEventToggle',
    thingsToNote: 'thingsToNote',
    eventName: 'eventName',
    eventDescription: 'eventDescription',
    eventInformation: 'eventInformation',
    setupTaskType: 'setupTaskType',
    additionTitle: 'additionTitle',
    additionDescription: 'additionDescription',
    blockTitle: 'blockTitle',
    blockDescription: 'blockDescription',
    blockImages: 'blockImages',
    blockIsRequired: 'blockIsRequired',
    uploadPhotos: 'uploadPhotos',
    allowDownloadToggle: 'allowDownloadToggle',
    numberOfPhotos: 'numberOfPhotos',
    blockIsLongAnswer: 'blockIsLongAnswer',
    options: 'options',
    blockIsMultiAnswer: 'blockIsMultiAnswer',
    blockHasOthers: 'blockHasOthers',
    blockQuestionNumMin: 'blockQuestionNumMin',
    blockQuestionNumMax: 'blockQuestionNumMax',
    blockQuestionTitle: 'blockQuestion',
    ageMin: 'ageMin',
    ageMax: 'ageMax',
    gender: 'gender',
    occupation: 'occupation',
    rank1: 'rank1',
    rank2: 'rank2',
    conflictInput: 'conflictInput',
    conflictTitle: 'conflictTitle',
    freeInput: 'freeInput',
    profileTypes: 'profileTypes',
    min: 'min',
    max: 'max',
    campaignRequirement: 'campaignRequirement',
    registrationFieldsHeader: 'registrationFieldsHeader',
    registrationCollectFollowerCount: 'registrationCollectFollowerCount',
    templateBrand: 'templateBrand',
    templateBudget: 'templateBudget',
    templatePurchaseNeeds: 'templatePurchaseNeeds',
    templatePlatformPost: 'templatePlatformPost',
    templateCredibilityNeeds: 'templateCredibilityNeeds',
    templateSelection: 'templateSelection',
    templateCampaignName: 'templateCampaignName',
    templateCategories: 'templateCategories',
    templateBannerImage: 'templateBannerImage',
    templateRegistrationEnable: 'templateRegistrationEnable',
    templateStartDate: 'templateStartDate',
    templatePayoutDeadline: 'templatePayoutDeadline',
    templateProducts: 'templateProducts',
    templateMinimumPurchaseQuantity: 'templateMinimumPurchaseQuantity',
    templateExampleMedia: 'templateExampleMedia',
    templateExampleMediaDescription: 'templateExampleMediaDescription',
    templatePurchaseLocations: 'templatePurchaseLocations',
    templateUniqueSellingPoints: 'templateUniqueSellingPoints',
    templateBrandHandles: 'templateProfileTags',
    templateCaptionHashtags: 'templateCaptionHashtags',
    templateAppName: 'templateAppName',
    templateReviewPlatform: 'templateReviewPlatform',
    templateDownloadLinks: 'templateDownloadLinks',
    templateReviewLink: 'templateReviewLink',
    templateSampleLinks: 'templateSampleLinks',
    templateStickerLink: 'templateStickerLink',
    templateIsCustomizedStickerText: 'templateCustomizedStickerTextInput',
    templateCustomizedStickerText: 'templateCustomizedStickerText',
    templatePaymentConfirmation: 'templatePaymentConfirmation',
    templateCustomiseToggle: 'templateCustomiseToggle',
    templateRequireCreateContent: 'templateRequireCreateContent',
    templateShippingFee: 'templateShippingFee',
    templateReviewApproval: 'templateReviewApproval',
    templateReviewImage: 'templateReviewImage',
    templateFollowPlatform: 'templateFollowPlatform',
    templateFollowPlatformLink: 'templateFollowPlatformLink',
    templateNumberOfVideo: 'templateNumberOfVideo',
    templateMandatoryGuidelines: 'templateMandatoryGuidelines',
} as const

export const templateSelectorIdentifiers: string[] = [
    fieldIdentifiers.templateBrand,
    fieldIdentifiers.templateBudget,
    fieldIdentifiers.templatePurchaseNeeds,
    fieldIdentifiers.templatePlatformPost,
    fieldIdentifiers.templateCredibilityNeeds,
    fieldIdentifiers.templateSelection,
    fieldIdentifiers.templateRequireCreateContent,
    fieldIdentifiers.templateReviewApproval,
    fieldIdentifiers.templateReviewImage,
]

export const templateDetailIdentifiers: string[] = [
    fieldIdentifiers.templateCampaignName,
    fieldIdentifiers.templateCategories,
    fieldIdentifiers.templateBannerImage,
    fieldIdentifiers.templateRegistrationEnable,
    fieldIdentifiers.templateStartDate,
    fieldIdentifiers.templatePayoutDeadline,
    fieldIdentifiers.templateProducts,
    fieldIdentifiers.templateMinimumPurchaseQuantity,
    fieldIdentifiers.templateExampleMedia,
    fieldIdentifiers.templateExampleMediaDescription,
    fieldIdentifiers.templatePurchaseLocations,
    fieldIdentifiers.templateUniqueSellingPoints,
    fieldIdentifiers.templateBrandHandles,
    fieldIdentifiers.templateCaptionHashtags,
    fieldIdentifiers.templateAppName,
    fieldIdentifiers.templateReviewPlatform,
    fieldIdentifiers.templateDownloadLinks,
    fieldIdentifiers.templateReviewLink,
    fieldIdentifiers.templateSampleLinks,
    fieldIdentifiers.templateStickerLink,
    fieldIdentifiers.templateIsCustomizedStickerText,
    fieldIdentifiers.templateCustomizedStickerText,
    fieldIdentifiers.templateShippingFee,
    fieldIdentifiers.templateFollowPlatform,
    fieldIdentifiers.templateFollowPlatformLink,
    fieldIdentifiers.templateNumberOfVideo,
    fieldIdentifiers.templateMandatoryGuidelines,
]

export const templateSummaryIdentifiers: string[] = [
    fieldIdentifiers.templateCustomiseToggle,
    fieldIdentifiers.templateBudget,
]

export const registrationIdentifiers: string[] = [
    fieldIdentifiers.brandName,
    fieldIdentifiers.campaignName,
    fieldIdentifiers.objective,
    fieldIdentifiers.categories,
    fieldIdentifiers.budget,
    fieldIdentifiers.slotNumber,
    fieldIdentifiers.isPrivate,
    fieldIdentifiers.registrationEnable,
    fieldIdentifiers.registrationMaxSlots,
    fieldIdentifiers.autoUpdateSubmissionStatus,
    fieldIdentifiers.submissionStatusFullMin,
    fieldIdentifiers.submissionStatusFillingFastMin,
    fieldIdentifiers.batchEnable,

    // We also display template comments if any, in Campaign editor's Set Up Campaign tab
    ...templateSelectorIdentifiers,
    ...templateDetailIdentifiers,
    ...templateSummaryIdentifiers,
]
export const publishIdentifiers: string[] = [
    fieldIdentifiers.campaignBanner,
    fieldIdentifiers.campaignDescription,
    fieldIdentifiers.campaignRequirement,
    fieldIdentifiers.ageMin,
    fieldIdentifiers.ageMax,
    fieldIdentifiers.gender,
    fieldIdentifiers.occupation,
    fieldIdentifiers.rank1,
    fieldIdentifiers.rank2,
    fieldIdentifiers.conflictInput,
    fieldIdentifiers.conflictTitle,
    fieldIdentifiers.freeInput,
    fieldIdentifiers.min,
    fieldIdentifiers.max,
    fieldIdentifiers.payoutDeadline,
    fieldIdentifiers.profileTypes,
]

export const tasksIdentifiers: string[] = [
    fieldIdentifiers.setupTitle,
    fieldIdentifiers.setupDescription,
    fieldIdentifiers.setupImages,
    fieldIdentifiers.setupTaskType,
    fieldIdentifiers.registrationFieldsHeader,
    fieldIdentifiers.blockTitle,
    fieldIdentifiers.blockDescription,
    fieldIdentifiers.blockImages,
    fieldIdentifiers.blockIsRequired,
    fieldIdentifiers.blockIsMultiAnswer,
    fieldIdentifiers.blockQuestionNumMin,
    fieldIdentifiers.blockQuestionNumMax,
    fieldIdentifiers.options,
    fieldIdentifiers.blockHasOthers,
    fieldIdentifiers.numberOfPhotos,
    fieldIdentifiers.blockIsLongAnswer,
    fieldIdentifiers.stepTitle,
    fieldIdentifiers.productName,
    fieldIdentifiers.productDescription,
    fieldIdentifiers.howToBuyTitle,
    fieldIdentifiers.productPhotos,
    fieldIdentifiers.productDescription,
    fieldIdentifiers.additionTitle,
    fieldIdentifiers.additionDescription,
    fieldIdentifiers.eventName,
    fieldIdentifiers.eventDescription,
    fieldIdentifiers.eventInformation,
    fieldIdentifiers.purchaseProductToggle,
    fieldIdentifiers.attendEventToggle,
    fieldIdentifiers.thingsToNote,
    fieldIdentifiers.stepDescription,
    fieldIdentifiers.engagementMetrics,
    fieldIdentifiers.videoCodeToggle,
    fieldIdentifiers.linkInBioToggle,
    fieldIdentifiers.photoRequirementDos,
    fieldIdentifiers.photoRequirementDonts,
    fieldIdentifiers.profileTags,
    fieldIdentifiers.captionRequirementHashtags,
    fieldIdentifiers.examplePhotos,
    fieldIdentifiers.examplePhotosDescription,
    fieldIdentifiers.captionRequirementDos,
    fieldIdentifiers.captionRequirementDonts,
    fieldIdentifiers.uploadPhotos,
    fieldIdentifiers.allowDownloadToggle,
    fieldIdentifiers.schedulePostToggle,
    fieldIdentifiers.start,
    fieldIdentifiers.end,
    fieldIdentifiers.reviewDuration,
    fieldIdentifiers.invitationExpiry,
    fieldIdentifiers.payoutBase,
    fieldIdentifiers.extraPayoutTitle,
    fieldIdentifiers.extraPayoutDescription,
    fieldIdentifiers.extraPayoutCost,
    fieldIdentifiers.extraPayoutMin,
    fieldIdentifiers.extraPayoutMax,
    fieldIdentifiers.engagementToggle,
    fieldIdentifiers.engagementCost,
    fieldIdentifiers.engagementMin,
    fieldIdentifiers.engagementMax,
]
